export const CHARGEBACKS_SHOPIFY_APP_URL = "https://apps.shopify.com/redo";
